import { useLayoutEffect, useState } from 'react';

export type UseConditionalTableScrollOptions = {
  dataLength: number;
  pageSize?: number;
  viewportOffset: number;
  rowHeight?: number;
  headerHeight?: number;
  paginationHeight?: number;
};

export const useConditionalTableScroll = ({
  dataLength,
  pageSize = 10,
  viewportOffset,
  rowHeight = 55,
  headerHeight = 55,
  paginationHeight = 64,
}: UseConditionalTableScrollOptions) => {
  const [scrollConfig, setScrollConfig] = useState<{ y: string } | undefined>();

  useLayoutEffect(() => {
    const currentPageRowCount = Math.min(dataLength, pageSize);
    const actualContentHeight = currentPageRowCount * rowHeight + headerHeight + paginationHeight;
    const maxAvailableHeight = window.innerHeight - viewportOffset;
    const shouldEnableScroll = actualContentHeight > maxAvailableHeight;

    setScrollConfig(shouldEnableScroll ? { y: `calc(100vh - ${viewportOffset}px)` } : undefined);
  }, [dataLength, pageSize, viewportOffset, rowHeight, headerHeight, paginationHeight]);

  return scrollConfig;
};
